var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from "react";
import Stack from "syf-component-library/ui/spacing/Stack";
import { Body } from "syf-component-library/ui/typography";
import { useTranslation } from "react-i18next";
import { ErrorActionButtons, ErrorImage, ErrorImageCard, ImageContentWrapper, LargeButton, Subtitle, Title, } from "./subcomponents";
import { PAGE_NAME } from "../../../const/analytics";
import { useVantageContext } from "../../../context/vantageContext";
import triggerVantageAnalytics from "../../../helpers/triggerVantageAnalytics";
import { useConfig } from "../../../hooks/useConfig";
import useIsTablet from "../../../hooks/useIsTablet";
import VantageTrans from "../../atoms/VantageTrans";
var ErrorPage = function (_a) {
    var title = _a.title, subtitle = _a.subtitle, _b = _a.hasDescription, hasDescription = _b === void 0 ? true : _b;
    var t = useTranslation().t;
    var navigateTo = useVantageContext().navigateTo;
    var isTablet = useIsTablet();
    var assets = useConfig().hosts.assets;
    useEffect(function () {
        return triggerVantageAnalytics({
            pageName: PAGE_NAME.VANTAGE_ERROR,
            errorMessage: isTablet
                ? t(title || "errorPage.title", { lng: "en" }).replace("\n", " ")
                : t(title || "errorPage.mobileTitle", { lng: "en" }),
            message: t(subtitle || "errorPage.subTitle", { lng: "en" }),
        });
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [title, subtitle, isTablet]);
    return (_jsxs(ImageContentWrapper, __assign({ "data-cy-include": true, "data-testid": "vantage-error" }, { children: [_jsx(ErrorImage, { src: "".concat(assets, "/assets/vantage/cat_error.PNG"), alt: "error" }), _jsxs(ErrorImageCard, { children: [_jsx(Stack, { size: "large" }), _jsx(Title, __assign({ as: "h1", weight: "semiBold" }, { children: isTablet ? (_jsx(VantageTrans, { i18nKey: title || "errorPage.title" })) : (_jsx(VantageTrans, { i18nKey: title || "errorPage.mobileTitle" })) })), _jsx(Stack, { size: "large" }), _jsx(Subtitle, __assign({ hasDescription: hasDescription }, { children: _jsx(VantageTrans, { i18nKey: subtitle || "errorPage.subTitle" }) })), _jsx(Stack, { size: "large", hideOnBreakpointDown: hasDescription ? undefined : "medium" }), hasDescription && (_jsx(Body, { children: _jsx(VantageTrans, { i18nKey: "errorPage.description" }) })), _jsx(Stack, { size: "large" }), _jsx(ErrorActionButtons, { children: _jsx(LargeButton, __assign({ onClick: navigateTo, buttonType: "primary", type: "button", "data-type": "credit score", "data-analytics": "clicktrackingevent", "data-reason": "account manager" }, { children: _jsx(VantageTrans, { i18nKey: "errorPage.accountManager" }) })) }), _jsx(Stack, { size: "large" })] })] })));
};
export default ErrorPage;
